import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import HoldingsContainer from './HoldingsContainer';

const schema: JSONSchema7 = {
    title: 'Holdings Container',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        containerTitles: headingsSchema,
        dataKey: {
            type: 'string',
            title: 'Data key',
            default: '',
        },
        holdings: {
            type: 'array',
            title: 'Holdings to include',
            items: {
                type: 'object',
                properties: {
                    name: { type: 'string', description: 'Holding Name' },
                    title: { type: 'string', description: 'Chart Title' },
                    subTitle: { type: 'string', description: 'Chart Sub Title' },
                    showChartTableOnly: {
                        type: 'boolean',
                        title: 'Show only chart table',
                        default: false,
                    },
                    pieTableHeaderRow: {
                        type: 'string',
                        title: 'Pie Table Header Row',
                        default: '',
                        description: 'Enter comma seperated values',
                    },
                    altText: {
                        type: 'string',
                        title: 'Alt Text',
                        default: '',
                    },
                    headingLevel: {
                        type: 'number',
                        title: 'Title Level',
                        default: 5,
                        enum: [1, 2, 3, 4, 5, 6],
                    },
                    subTitleLevel: {
                        type: 'number',
                        title: 'Sub Title Level',
                        default: 6,
                        enum: [1, 2, 3, 4, 5, 6],
                    },
                },
                required: ['name'],
            },
        },
        ...customSchemas.highchartOptionsSchema.HighchartOptionsSchema.schema(),
        pieTableHeaderRow: {
            type: 'string',
            title: 'Pie Table Header Row',
            default: '',
            description: 'Enter comma seperated values',
        },
        columns: {
            type: 'array',
            title: 'Add Pie Table columns',
            items: {
                type: 'object',
                properties: {
                    label: {
                        type: 'string',
                        description: 'Column header text. Note- Add "swatch" for color value',
                    },
                    value: {
                        type: 'string',
                        description: 'Coulmn data key. Note- Add alt value for color swatch',
                    },
                    isIncludeColor: { type: 'boolean', description: 'Is Include color' },
                },
            },
        },
        transformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
        paletteId: {
            type: 'string',
            title: 'Palette ID',
            default: 'pieChartPalette',
        },
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
    },
    dependencies: {
        transformData: {
            oneOf: [
                {
                    properties: {
                        transformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default: 'return (data) => { return data }',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'paletteId',
            'containerTitles',
            'dataKey',
            'holdings',
            'options',
            'pieTableHeaderRow',
            'columns',
        ],
        'Transform Data': ['transformData', 'functionToTransform'],
        Accessibility: ['disableTabStaticData'],
    },
];

const HoldingsWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        containerTitles: {
            items: {
                headerText: {
                    'ui:widget': 'ResourcePicker',
                },
            },
        },
        pieTableHeaderRow: {
            'ui:widget': 'ResourcePicker',
        },
        holdings: {
            items: {
                name: {
                    'ui:widget': 'ResourcePicker',
                },
                title: {
                    'ui:widget': 'ResourcePicker',
                },
                subTitle: {
                    'ui:widget': 'ResourcePicker',
                },
                pieTableHeaderRow: {
                    'ui:widget': 'ResourcePicker',
                },
                altText: {
                    'ui:widget': 'ResourcePicker',
                },
                headingLevel: {
                    'ui:widget': 'CustomSelect',
                },
                subTitleLevel: {
                    'ui:widget': 'CustomSelect',
                },
                showChartTableOnly: {
                    'ui:widget': 'CustomCheckbox',
                },
            },
        },
        paletteId: {
            'ui:widget': 'PaletteSelect',
        },
        styles: {
            'ui:widget': 'CSSEditor',
        },
        functionToTransform: { 'ui:widget': 'JSEditor' },
        dataKey: {
            'ui:widget': 'CustomTextInput',
        },
        ...customSchemas.highchartOptionsSchema.HighchartOptionsSchema.uiSchema,
        columns: {
            items: {
                label: {
                    'ui:widget': 'ResourcePicker',
                },
                value: {
                    'ui:widget': 'CustomTextInput',
                },
                isIncludeColor: { 'ui:widget': 'CustomCheckbox' },
            },
        },
        disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
    },
    templateView: HoldingsContainer,
    id: 'HoldingsContainer',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default HoldingsWidget;
